<template>
  <div class="join">
    <el-dialog width="500px" title="添加设备型号" :visible.sync="showEditMember">
      <edit-type v-if="showEditMember" :memberInfo='memberInfo'></edit-type>
    </el-dialog>
    <div class="title"><img src="../assets/circle.png"><b>设备型号管理</b><el-button class="addBn" type="primary" @click="eidtMemberFn()">添加</el-button></div>
    <div class="joinList">
      <table class="activeTable" cellspacing="0" cellpadding="0">
        <tr><th width="8%">序号</th><th width="20%">设备名称</th><th width="20%">设备型号</th><th width="20%">单路/双路</th><th width="10%">操作</th></tr>
        <tr v-for="(item,index) in joinList" :key="item.id">
          <td align="center">{{index+(cur-1)*10+1|cutserial}}</td>
          <td align="center"><span :title="item.deviceName">{{item.deviceName}}</span></td>
          <td align="center">{{item.deviceType}}</td>
          <td align="center">{{item.model}}</td>
          <td align="center" class="options"><span @click="deleteType(item.id)">删除</span></td>
        </tr>
      </table>
      <div class="nodata" v-if="showNodata"><img src="../assets/no_data.png"><p>暂无数据</p></div>
    </div>
    <div class="page" v-if="!showNodata"><page :total='total' :pageSize='pageSize' @pageNum="getPage"></page></div>
    <Loading v-if="showLoading"></loading>
  </div>
</template>

<script>
import {getTypeList,deleteDevice} from '@/api/api'
import bus from '@/bus'
import Page from '@/components/Page'
import {formatDate} from '@/api/common'
import EditType from '@/components/EditType'
import Loading from '@/components/Loading'
export default {
  name: 'device',
  data () {
    return {
      joinList:[],
      memberInfo:{},
      keyword:'',
      showNodata:false,
      showEditMember:false,
      showLoading:false,
      pageSize: 10, //每页几条
      cur: 1,//当前页码
      total:0 //总条数
    }
  },
  mounted(){
    bus.$off('hidePop')
    bus.$on('hidePop',res=>{
      this.showEditMember=res
    })
    bus.$off('closeEditMember')
    bus.$on('closeEditMember',res=>{
      this.showEditMember=false
      this.getData()
    })
    this.getData()
  },
  methods:{
    deleteType(id){
      this.$confirm('是否删除该设备型号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data=JSON.stringify({
          deviceTypeId:id
        })
        deleteDevice(data).then(res=>{
           if(res.data.state==200){
             this.getData()
             this.$message({
                message: '删除成功',
                type: 'success'
             })
           }else{
             this.$message({
                message: '操作失败',
                type: 'warning'
             })
           }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    eidtMemberFn(index){
      this.memberInfo=this.joinList[index]
      this.showEditMember=true
    },
    getData(key){
      this.showLoading=true
      getTypeList().then(res=>{
        this.showLoading=false
        if(res.data.state==200){
          const {data}=res.data
          if(data==''||data==null){
            this.showNodata=true
          }else{
            this.showNodata=false
          }
          this.total=res.data.totalCount
          this.joinList=data
        }
      }).catch(err=>{
        this.showNodata=false
      })
    },
    getPage(data){
      this.cur=data
    }
  },
  filters:{
    getTime(time) {
     var date = new Date(time);
     return formatDate(date, 'yyyy-MM-dd h:m:s').slice(0,16);
    },
    cutstr(val,len){
      if(val){
        return val.slice(0,len)
      }
    },
    cutserial(val){
       var len=val.toString().length
       console.log(len)
        if(len==1){
          return '00'+val
        }
        if(len==2){
          return '0'+val
        }
    }
  },
  watch:{
    cur(val){
      this.getData('')
    }
  },
  components:{
    Page,
    EditType,
    Loading
  },
  // beforeRouteEnter(to,from,next) {
  //   var that=this
  //   var manager=localStorage.getItem('manager')
  //   if(manager=='M'){
  //     next()
  //   }else{
  //      alert('您没有访问权限')
  //      next('/login')
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   .searchDiv {height:50px;line-height:50px;}
   .el-input {width:250px;margin-right:10px;}
   .joinList {height:500px;margin-top:20px;}
   .activeTable {width:100%;margin-top:5px;}
   .activeTable tr {height:40px;line-height:45px;}
   .activeTable tr input {width:16px;height:16px;position:relative;top:2px;}
   .activeTable tr th {font-weight: 100;background:#f6f6f6;}
   .activeTable tr td {border-bottom: #eee 1px solid;}
   .page {height:50px;}
   .searchDivLeft {width:400px;float: left;}
   .searchDivRight {width: 300px;text-align: right;float: right;}
   .options span {color:#357af1;margin-left:10px;margin-right:10px;cursor: pointer;}
   .addBn {float: right;}
</style>



// WEBPACK FOOTER //
// src/views/DeviceType.vue